import { render, staticRenderFns } from "./dashboard-big-number-a.vue?vue&type=template&id=06fca867&scoped=true&"
import script from "./dashboard-big-number-a.vue?vue&type=script&lang=js&"
export * from "./dashboard-big-number-a.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-big-number-a.vue?vue&type=style&index=0&id=06fca867&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fca867",
  null
  
)

export default component.exports